/* eslint-disable no-magic-numbers, react/no-multi-comp */
import React from 'react';
import Icon from "@scentregroup/ui/components/icon";
import Paragraph from "@scentregroup/ui/components/paragraph";
import { formatTimeAMPM, formatDayAndMonth } from '../date-format-helpers';
import ExternalLink from '../../components/external-link';
import { ACCORDION_ORDER, DEFAULT_CALENDAR } from '../../constants';
import style from '../../components/info-accordion/index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getFileName = (startAt, centreSlug) => "calendar-invitation-".concat(centreSlug, "-").concat(startAt.slice(0, 10), ".ics");
const getOccDate = (occ, centreTime) => {
  const {
    startAt: centreStart,
    endAt: centreEnd
  } = centreTime.fromEntryISO(occ);
  return "".concat(centreTime.formatHumanDay(centreStart), ", ").concat(formatTimeAMPM(centreStart), " - ").concat(formatTimeAMPM(centreEnd));
};
const getPastOcc = (occ, centreTime) => {
  const {
    startAt: centreStart,
    endAt: centreEnd
  } = centreTime.fromEntryISO(occ);
  return "".concat(centreTime.formatHumanDay(centreStart), " ").concat(formatDayAndMonth(centreStart), ", ").concat(formatTimeAMPM(centreStart), " - ").concat(formatTimeAMPM(centreEnd));
};
const getOccTitle = centreStart => {
  const startDate = centreStart.format('D');
  const dateOrdinal = centreStart.format('Do').substr(-2);
  const month = centreStart.format('MMM');
  return /*#__PURE__*/_jsxs("div", {
    "data-id": "get-accordion-event-detail_index_getOccTitle_div",
    children: [/*#__PURE__*/_jsxs("div", {
      type: "large",
      className: style.rowTitleText,
      "data-id": "get-accordion-event-detail_index_getOccTitle_div_div_1",
      children: [startDate, /*#__PURE__*/_jsx("span", {
        className: style.rowTitleSuperScript,
        "data-id": "get-accordion-event-detail_index_getOccTitle_div_span",
        children: dateOrdinal
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: style.rowSubtitleText,
      "data-id": "get-accordion-event-detail_index_getOccTitle_div_div",
      children: month
    })]
  });
};
const getOccContent = (row, centreSlug, centreTime) => /*#__PURE__*/_jsxs(Paragraph, {
  "data-id": "get-accordion-event-detail_index_getOccTitle_Paragraph",
  children: [getOccDate(row, centreTime), '. ', row.calendar && /*#__PURE__*/_jsx(ExternalLink, {
    className: style.rowLink,
    url: row.calendar[DEFAULT_CALENDAR],
    download: getFileName(row.startAt, centreSlug),
    "data-id": "get-accordion-event-detail_index_getOccTitle_ExternalLink",
    children: "Add to Calendar"
  })]
});
const getOccurrenceRows = (occ, centreSlug, centreTime) => {
  const firstOcc = occ.times[0];
  const remainingOcc = occ.times.slice(1);
  let rows = [{
    rowType: 'occurrence',
    rows: [{
      title: getOccTitle(centreTime.fromISOIgnoringOffset(firstOcc.startAt)),
      content: getOccContent(firstOcc, centreSlug, centreTime)
    }]
  }];
  if (occ.times.length > 1) {
    const rowsRemainingCount = remainingOcc.length;
    rows = [...rows, {
      expandTitle: {
        opened: 'Hide dates',
        closed: "Show ".concat(rowsRemainingCount, " more ").concat(rowsRemainingCount === 1 ? 'date' : 'dates')
      },
      rowType: 'occurrence',
      rows: remainingOcc.map(row => ({
        title: getOccTitle(centreTime.fromISOIgnoringOffset(row.startAt)),
        content: getOccContent(row, centreSlug, centreTime)
      }))
    }];
  }
  return rows;
};
const getRow = (rowType, rowText, centreSlug) => {
  if (rowText) {
    switch (rowType) {
      case 'location':
        {
          return {
            title: /*#__PURE__*/_jsx(Icon, {
              className: style.rowIcon,
              type: "location-drop-pin",
              "data-id": "get-accordion-event-detail_index_getOccTitle_Icon"
            }),
            content: /*#__PURE__*/_jsxs(Paragraph, {
              "data-id": "get-accordion-event-detail_index_getOccTitle_Paragraph",
              children: [/*#__PURE__*/_jsxs("span", {
                "data-id": "get-accordion-event-detail_index_getOccTitle_Paragraph_span",
                children: [rowText, ". "]
              }), /*#__PURE__*/_jsx(ExternalLink, {
                className: style.rowLink,
                url: "/".concat(centreSlug, "/centre-map"),
                "data-id": "get-accordion-event-detail_index_getOccTitle_Paragraph_ExternalLink",
                children: "View Map"
              })]
            })
          };
        }
      case 'priceInfo':
        {
          return {
            title: /*#__PURE__*/_jsx(Icon, {
              className: style.rowIcon,
              type: "offer",
              "data-id": "get-accordion-event-detail_index_getOccTitle_Icon"
            }),
            content: /*#__PURE__*/_jsxs(Paragraph, {
              "data-id": "get-accordion-event-detail_index_getOccTitle_Paragraph",
              children: [" Price: ", rowText, " "]
            })
          };
        }
      default:
        {
          return {};
        }
    }
  } else {
    return null;
  }
};
const getAccordionRows = (rowItems, centreSlug) => ({
  rowType: 'eventDetails',
  rows: rowItems.map(x => getRow(x.rowType, x.rowText, centreSlug)).filter(Boolean)
});
const isRowWithOccs = (rowType, entry) => rowType.length === 1 && entry[rowType] && entry[rowType].times.length;
const isRowWithText = (rowType, entry) => Boolean(entry[rowType]) && {
  rowType,
  rowText: entry[rowType]
};
export const getPastOccurrences = (pastOccurrences, centreTime) => [{
  expandTitle: {
    closed: 'Show Past Events',
    opened: 'Hide past events'
  },
  rowType: 'pastOccurrences',
  rows: pastOccurrences.map(pastOccurrence => ({
    content: getPastOcc(pastOccurrence, centreTime)
  }))
}];
export const getAccordionEventDetail = (entry, centreSlug, centreTime) => ACCORDION_ORDER.reduce((acc, rowType) => {
  if (rowType[0] === 'occurrences') {
    if (isRowWithOccs(rowType, entry)) {
      return [...acc, ...getOccurrenceRows(entry[rowType], centreSlug, centreTime)];
    } else {
      return [];
    }
  } else {
    const rowItems = rowType.map(x => isRowWithText(x, entry)).filter(Boolean);
    return [...acc, getAccordionRows(rowItems, centreSlug)];
  }
}, []);